<div class="d-flex flex-column">
	<div class="d-flex">
		<div class="d-flex flex-column card p-0 h-100">
			<div class="d-flex">
				<div class="h3 mx-4 mt-2 mb-1">Setup</div>
			</div>
			<p-divider></p-divider>
			<div class="p-2">
				<div class="ms-2">
					<label for="active">Active</label>
					<p-inputSwitch id="active" class="ms-2" [(ngModel)]="timeRangeSelected.active" [disabled]="timeRangeSelected.isFromPos"> </p-inputSwitch>
				</div>

				<div class="d-flex mt-4 w-100">
					<span class="p-float-label w-100 mx-2 mt-2">
						<input
							pInputText
							type="text"
							id="name"
							name="name"
							[(ngModel)]="timeRangeSelected.name"
							class="w-100"
							[disabled]="timeRangeSelected.isFromPos"
						/>
						<label for="name" class="ms-2">Name</label>
					</span>
				</div>
				<div class="d-flex mt-4">
					<div class="ms-2">
						<span class="p-float-label">
							<p-calendar
								[(ngModel)]="timeRangeSelected.startDate"
								id="startDate"
								name="startDate"
								appendTo="body"
								[disabled]="timeRangeSelected.isFromPos"
							>
							</p-calendar>
							<label for="startDate" class="ms-2">Start Date</label>
						</span>
					</div>
					<div class="ms-2">
						<span class="p-float-label me-2">
							<p-calendar
								[(ngModel)]="timeRangeSelected.endDate"
								id="endDate"
								name="endDate"
								appendTo="body"
								[disabled]="timeRangeSelected.isFromPos"
							>
							</p-calendar>
							<label for="endDate" class="ms-2">End Date</label>
						</span>
					</div>
				</div>
			</div>
		</div>
		<div class="d-flex flex-column card p-0 h-100 flex-fill ms-2">
			<div class="d-flex">
				<div class="h3 mx-4 mt-2 mb-1">Menu Message</div>
			</div>
			<p-divider></p-divider>
			<div class="p-2">
				<span class="p-float-label w-100 mt-2">
					<textarea pInputTextarea name="timeRangeMessage" id="timeRangeMessage" [(ngModel)]="timeRangeSelected.message" class="w-100"></textarea>
					<label for="timeRangeMessage" class="ms-2">Menu availability message</label>
				</span>
			</div>
		</div>
	</div>
</div>

<div class="d-flex card p-0 my-2">
	<div class="d-flex">
		<div class="h3 mx-4 mt-2 mb-1">Time Setup</div>
	</div>
	<p-divider></p-divider>
	<div class="p-2">
		<div class="d-flex justify-content-center mt-3">
			<div *ngIf="timeRangeSelected.isFromPos" class="text-lowercase ql-color-red">this store-level time range cannot be edited here.</div>
		</div>

		<div *ngFor="let timeRangeTime of timeRangeSelected.OOTimeRangeTimes" class="mt-4 ms-2">
			<div class="p-grid">
				<div class="col-1">
					<div>{{ moment(timeRangeTime.day, "d").format("dddd") }}</div>
				</div>
				<div class="col-11 d-flex flex-row">
					<span class="p-float-label">
						<p-calendar
							[(ngModel)]="timeRangeTime.startTime"
							name="tr#{{ timeRangeTime.day }}#start1"
							[disabled]="timeRangeSelected.isFromPos"
							id="tr#{{ timeRangeTime.day }}#start1"
							[timeOnly]="true"
							appendTo="body"
							hourFormat="12"
							styleClass="mx-2"
							dateFormat=""
						>
						</p-calendar>
						<label for="tr#{{ timeRangeTime.day }}#start1" class="ms-2">{{ moment(timeRangeTime.day, "d").format("ddd") }} Start 1</label>
					</span>
					<span class="p-float-label me-">
						<p-calendar
							[(ngModel)]="timeRangeTime.endTime"
							name="tr#{{ timeRangeTime.day }}#end1"
							[disabled]="timeRangeSelected.isFromPos"
							id="tr#{{ timeRangeTime.day }}#end1"
							[timeOnly]="true"
							appendTo="body"
							hourFormat="12"
							styleClass="me-2 me-4"
						>
						</p-calendar>
						<label for="tr#{{ timeRangeTime.day }}#end1" class="ms-2">{{ moment(timeRangeTime.day, "d").format("ddd") }} End 1</label>
					</span>
					<span class="p-float-label ms-4">
						<p-calendar
							[(ngModel)]="timeRangeTime.startTime2"
							name="tr#{{ timeRangeTime.day }}#start2"
							[disabled]="timeRangeSelected.isFromPos"
							id="tr#{{ timeRangeTime.day }}#start2"
							[timeOnly]="true"
							appendTo="body"
							hourFormat="12"
							styleClass="me-2"
						>
						</p-calendar>
						<label for="tr#{{ timeRangeTime.day }}#start2" class="ms-2">{{ moment(timeRangeTime.day, "d").format("ddd") }} Start 2</label>
					</span>
					<span class="p-float-label">
						<p-calendar
							[(ngModel)]="timeRangeTime.endTime2"
							name="tr#{{ timeRangeTime.day }}#end2"
							[disabled]="timeRangeSelected.isFromPos"
							id="tr#{{ timeRangeTime.day }}#end2"
							[timeOnly]="true"
							appendTo="body"
							hourFormat="12"
							styleClass="mx-2 me-4"
						>
						</p-calendar>
						<label for="tr#{{ timeRangeTime.day }}#end2" class="ms-2">{{ moment(timeRangeTime.day, "d").format("ddd") }} End 2</label>
					</span>
					<p-button
						pRipple
						*ngIf="!copiedRow && !timeRangeSelected.isFromPos && copiedRow?.day !== timeRangeTime.day"
						styleClass="p-button-raised p-button-secondary mx-2"
						(click)="copyTimeRangeTimeRow(timeRangeTime.day)"
					>
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'copy']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
					<p-button
						pRipple
						*ngIf="copiedRow && !timeRangeSelected.isFromPos && copiedRow?.day === timeRangeTime.day"
						styleClass="p-button-raised p-button-danger mx-2"
						(click)="cancelCopyTimeRangeRow()"
					>
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'times-circle']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
					<p-button
						pRipple
						*ngIf="copiedRow && !timeRangeSelected.isFromPos && copiedRow?.day !== timeRangeTime.day"
						styleClass="p-button-raised p-button-success mx-2"
						(click)="pasteTimeRangeTimeRow(timeRangeTime.day)"
					>
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'paste']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
				</div>
			</div>
		</div>
	</div>
</div>
